import { Icon } from "@/lib/Icon";

/** The System Membership card at icon size: a square of the card's brushed
 * metal with the white System mark. Decorative; pair it with visible text. */
export function MemberCardIcon({ className = "" }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={`inline-flex h-30 w-30 shrink-0 items-center justify-center [background:var(--member-metal)] [box-shadow:var(--member-metal-edges)] ${className}`}
    >
      <span className="flex w-17 text-white [filter:drop-shadow(0_1px_1px_rgba(0,0,0,0.45))]">
        <Icon name="Mark Line" viewBox="0 0 32 30" />
      </span>
    </span>
  );
}
